import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import * as Routes from '@/modules/routes';

interface Named { id: number; title: string | null }

export interface Misclaim {
  course_id: string | null;
  /** Repointing would displace a holder already delivering grades — the duplicate trap. */
  displacing: boolean;
  held_by: Named[];
  label: string | null;
  line_item_id: string;
  owner: Named;
  resource_link_id: string | null;
}

/** A column nobody holds that one of the teacher's assignments should — a course it is missing. */
export interface Attachable {
  course_id: string | null;
  /** `named`: the LMS names the owner. `orphaned`: it names a deleted assignment; matched by title. */
  kind: 'named' | 'orphaned';
  label: string | null;
  line_item_id: string;
  named_id: number | null;
  owner: Named;
  resource_link_id: string | null;
}

export interface MisclaimPayload {
  attachable?: Attachable[];
  courses_read?: number;
  error?: string;
  rows?: Misclaim[];
  unreadable?: number;
}

const useMisclaims = (stafferId: string, enabled: boolean) => useQuery({
  enabled: enabled && stafferId.trim().length > 0,
  queryFn: async (): Promise<MisclaimPayload> => {
    const { data } = await axios.get(
      Routes.plato_api_sysadmin_grade_sync_misclaims_path(),
      { params: { staffer_id: stafferId } },
    );

    return data.data;
  },
  queryKey: ['gradeSyncMisclaims', stafferId],
  staleTime: 5 * 60 * 1000,
});

export default useMisclaims;
